<template>
  <div class="dropdown column-selector-dropdown">
    <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="mdi mdi-view-column mr-1"></i> Սյուներ
    </button>
    <div class="dropdown-menu dropdown-menu-right p-2" style="min-width:200px" @click.stop>
      <div v-for="col in allColumns" :key="col.key" class="form-check mb-1">
        <input
          :id="`col-${storageKey}-${col.key}`"
          type="checkbox"
          class="form-check-input"
          :checked="localVisible.includes(col.key)"
          @change="toggle(col.key)"
        />
        <label :for="`col-${storageKey}-${col.key}`" class="form-check-label" style="font-size:0.8rem;cursor:pointer">
          {{ col.label }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColumnSelector',
  props: {
    allColumns: { type: Array, required: true },
    visible: { type: Array, required: true },
    storageKey: { type: String, required: true },
  },
  computed: {
    localVisible() { return this.visible },
  },
  methods: {
    toggle(key) {
      const current = [...this.visible]
      const idx = current.indexOf(key)
      if (idx > -1) {
        if (current.length > 1) current.splice(idx, 1)
      } else {
        const order = this.allColumns.map(c => c.key)
        current.push(key)
        current.sort((a, b) => order.indexOf(a) - order.indexOf(b))
      }
      try { localStorage.setItem(this.storageKey, JSON.stringify(current)) } catch {}
      this.$emit('update:visible', current)
    },
  },
}
</script>
